// src/hooks/useOwnerModeration.ts — async loader for the owner moderation overview.
import { useEffect, useState } from 'react';
import { ownerService } from '@/core/services/ownerService';
import type { ModerationOverview } from '@/core/models';

export interface OwnerModerationHook {
  data: ModerationOverview | null;
  loading: boolean;
  error: string | null;
}

export function useOwnerModeration(): OwnerModerationHook {
  const [data, setData] = useState<ModerationOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional loader flag
    setLoading(true);
    ownerService
      .getModerationOverview()
      .then((d) => { if (alive) { setData(d); setError(null); } })
      .catch(() => { if (alive) setError('Failed to load moderation overview'); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { data, loading, error };
}
